import { format, parse, parseISO, addDays, addMonths, addYears, isValid } from 'date-fns';
function ok() { return { ok: true }; }
function fail(field, message) {
    return { ok: false, errors: [{ field, message }] };
}
function parseDate(input, inputFormat) {
    if (input === null || input === undefined)
        return null;
    const s = String(input).trim();
    if (s.length === 0)
        return null;
    const parsed = inputFormat ? parse(s, inputFormat, new Date()) : parseISO(s);
    return isValid(parsed) ? parsed : null;
}
const dateFormat = {
    id: 'date_format',
    family: 'date',
    label: 'Date format',
    description: 'Reformat a date. Use date-fns patterns (yyyy, MM, dd, HH, mm, ss, etc.).',
    defaultConfig: { outputFormat: 'yyyy-MM-dd' },
    evaluate: (input, config) => {
        const c = config;
        const d = parseDate(input, c.inputFormat);
        if (!d)
            return input === null || input === undefined ? '' : String(input);
        try {
            return format(d, c.outputFormat);
        }
        catch {
            return input === null || input === undefined ? '' : String(input);
        }
    },
    validate: (config) => {
        const c = config;
        if (typeof c.outputFormat !== 'string' || c.outputFormat.length === 0)
            return fail('outputFormat', 'outputFormat is required');
        return ok();
    },
    formSchema: [
        { key: 'outputFormat', label: 'Output format', type: 'text', required: true, helpText: 'date-fns pattern, e.g. yyyy-MM-dd' },
        { key: 'inputFormat', label: 'Input format (optional — auto-detects ISO if omitted)', type: 'text' },
    ],
    sampleSeeds: ['2026-04-15', '2026-12-01T08:30:00Z', '01/15/2026'],
};
const dateOffset = {
    id: 'date_offset',
    family: 'date',
    label: 'Date offset',
    description: 'Add or subtract days, months, or years.',
    defaultConfig: { amount: 0, unit: 'days' },
    evaluate: (input, config) => {
        const c = config;
        const d = parseDate(input);
        if (!d)
            return input === null || input === undefined ? '' : String(input);
        let shifted;
        switch (c.unit) {
            case 'days':
                shifted = addDays(d, c.amount);
                break;
            case 'months':
                shifted = addMonths(d, c.amount);
                break;
            case 'years':
                shifted = addYears(d, c.amount);
                break;
            default: return String(input);
        }
        // Return ISO date by default; downstream chain step (date_format) can reshape.
        return format(shifted, "yyyy-MM-dd'T'HH:mm:ssXXX");
    },
    validate: (config) => {
        const c = config;
        if (typeof c.amount !== 'number')
            return fail('amount', 'amount must be a number');
        if (!['days', 'months', 'years'].includes(c.unit ?? ''))
            return fail('unit', 'unit must be days/months/years');
        return ok();
    },
    formSchema: [
        { key: 'amount', label: 'Amount (negative subtracts)', type: 'number', required: true },
        { key: 'unit', label: 'Unit', type: 'select', required: true, options: [
                { value: 'days', label: 'Days' },
                { value: 'months', label: 'Months' },
                { value: 'years', label: 'Years' },
            ] },
    ],
    sampleSeeds: ['2026-04-15', '2026-01-01', '2026-12-31'],
};
export const dateOps = [dateFormat, dateOffset];
//# sourceMappingURL=date-ops.js.map